import * as styles from 'styles/pages/Styleguide.css'
import Highlights from 'components/features/pfm/Highlights/Highlights'
import { Insight as InsightInterface } from 'interfaces/insights'
import { HIGHLIGHTS } from 'fixtures/sg-insights'

const SGInsights = () => (
  <section className={ styles.sgSection }>
    <Highlights
      insights={ HIGHLIGHTS }
      dismissedInsights={ [] as InsightInterface[] }
      undismiss={ () => { } }
      onInsightShown={ (() => { }) as any }
      viewport='not-defined'
      isMobile={ false }
      isMobileOrTablet={ false }
    />
  </section>
)

export default SGInsights
